import { useDealersQuery } from './useDealersQuery';
import type { Dealer } from '../types/dealers.types';

const SINGLE_DEALER_PROBE = { per_page: 2, sellable_only: true, context: 'sales' } as const;

/** The caller's only dealer they can sell at, or null when they have none or several. */
export const useSingleVisibleDealer = (): { dealer: Dealer | null; settled: boolean } => {
    const { data, isSuccess, isError } = useDealersQuery(SINGLE_DEALER_PROBE);
    const dealer = data?.meta?.total === 1 && data.data.length === 1 ? data.data[0] : null;
    return { dealer, settled: isSuccess || isError };
};
